export default __webpack_public_path__ + "static/media/exportIcon.d49ab12c.svg";